import React from "react";
import { useQuery } from "@apollo/client";
import { dateToString } from "../../utils/date-converter";
import { GET_AUTHED_CLIENT_QUERY } from "../../graphql/queries/clients";
import Loader from "../../components/loader/loader";
import Button from "../../components/Button/Button";
import { useState } from "react";
import Modal from "../../components/modal/Modal";
import EditClient from "../../components/edit-client/edit-client";

const MyProfile = () => {
  const clientResponse = useQuery(GET_AUTHED_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });
  const [editClientModal, setEditClientModal] = useState(false);
  const onEditClient = () => {
    setEditClientModal((prev) => !prev);
  };

  if (clientResponse.loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (clientResponse.error) {
    return <div className="display-page__error">Something went wrong</div>;
  }

  return (
    <div className="display-page">
      <Modal modal={editClientModal} onClose={onEditClient} modalSize="large">
        <>
          <EditClient
            onCancel={onEditClient}
            clientData={clientResponse.data?.authenticatedClient}
            clientId={parseInt(clientResponse.data?.authenticatedClient?.id)}
            clientResponse={clientResponse}
            fieldsDisabled={true}
            type="Profile"
          />
        </>
      </Modal>
      <div className="display-page__details-wrapper">
        <div className="display-page__column-left">
          <div className="display-page__details-action">
            <Button
              onClick={onEditClient}
              name={"Edit"}
              className={"button--action"}
            />
          </div>
          <div className="display-page__details">
            <div className="display-page__details-row">
              <div className="display-page__details-key">Name</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.name}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Client ID</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.clientId}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Channel</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.tower.zonkeId} -{" "}
                {clientResponse.data.authenticatedClient.channel}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Package</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.package.name}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Mobile</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.phoneNumber}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Contact Method</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.contactMethod}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">W3W Address</div>
              <div className="display-page__details-value">
                {clientResponse.data.authenticatedClient.w3w}
              </div>
            </div>
            <div className="display-page__details-row">
              <div className="display-page__details-key">Date Added</div>
              <div className="display-page__details-value">
                {dateToString(
                  clientResponse.data.authenticatedClient.createdDate
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="display-page__graph"></div>
      </div>
    </div>
  );
};

export default MyProfile;
